import { di } from 'react-magnetic-di';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type HookActionsFunction,
	type Action,
	createHook,
	createStore,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import { BANNER_HEIGHT } from '../../constants.tsx';
import type { State } from './types.tsx';

export const isInIframe = () => {
	di(window);
	if (__SERVER__) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
};

// Fetching banner preferences and height in initial state to prevent layout shifts.
export const initialState: State = {
	get isDismissed() {
		return true;
	},
	get height() {
		return fg('jfp-magma-ssr-iv-cookie-consent-banner') ? BANNER_HEIGHT : 0;
	},
	hasInit: false,
};

export const actions = {
	onShow:
		(): Action<State> =>
		({ getState, setState }) => {
			setState({
				...(fg('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState()),
				isDismissed: false,
			});
		},
	onDismiss:
		(): Action<State> =>
		({ getState, setState }) => {
			setState({
				...(fg('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState()),
				isDismissed: true,
			});
		},
	setHeight:
		(height: number): Action<State> =>
		({ getState, setState }) => {
			setState({ ...(fg('jfp-magma-ssr-iv-cookie-consent-banner') ? {} : getState()), height });
		},
	init:
		(isDismissed: boolean): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed,
				hasInit: true,
			});
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'cookie-consent-banner',
	initialState,
	actions,
});

export const useCookieConsentBannerSettings = createHook(Store);

// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>>' is not assignable to type 'HookActionsFunction<{ readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>'.
export const useCookieConsentBannerSettingsActions: HookActionsFunction<Actions> =
	createActionsHook(Store);
